import { createApp } from "vue";
import App from "./App.vue";
import axios from "axios";
import "tailwindcss/tailwind.css";
import "./assets/tailwind.css";
import {
  applyAxiosAuthHeaders,
  clearSubscriberToken,
  invalidateSubscriptionSession,
  syncSubscriberSessionCookie,
} from "./auth";
import { globalState } from "./globalState"; // ✅ importás el estado

/* axios.defaults.timeout = 2500; */

localStorage.removeItem("token");
applyAxiosAuthHeaders();
syncSubscriberSessionCookie();

axios.interceptors.response.use(
  function(response) {
    return response;
  },
  async function(error) {
    const originalRequest = error?.config;
    if (error?.response?.status === 401 && originalRequest && !originalRequest._retry) {
      originalRequest._retry = true;
      globalState.tokenUpdated = false;
      if (localStorage.getItem("subscriberToken")) {
        await clearSubscriberToken();
      } else {
        applyAxiosAuthHeaders();
      }
      globalState.tokenUpdated = true;
      try {
        return await axios(originalRequest);
      } catch (retryError) {
        const st = retryError?.response?.status;
        if (st === 401 || st === 403) {
          await invalidateSubscriptionSession();
        }
        return Promise.reject(retryError);
      }
    }
    return Promise.reject(error);
  }
);

const app = createApp(App);
app.provide("globalState", globalState); // ✅ lo proveés
app.mount("#app");
